import { useQuery } from "@tanstack/react-query";

import { ApiCatalog } from "@/api";
import { logger } from "@/monitoring/utils";
import stringifyParams from "@/utils/stringifyParams";

export default function useGetDeliverySearch({
  queryParams,
}: {
  queryParams: Record<string, any>;
}) {
  const endpoint = ApiCatalog.search.endpoint.replace(/[/\s]*$/g, "");

  // Process content_types array into repeated query parameters
  const processedParams = { ...queryParams };
  let contentTypesString = "";

  if (Array.isArray(queryParams["content_types"])) {
    // Convert array to repeated query parameter string
    contentTypesString = queryParams["content_types"]
      .map((type: string) => `content_types=${type}`)
      .join("&");

    delete processedParams["content_types"];
  }

  // Build the URL with regular params + content_types string
  const regularParamsString = stringifyParams(processedParams);
  const fullQueryString = contentTypesString
    ? `${regularParamsString}&${contentTypesString}`
    : regularParamsString;

  const requestUrl = `${endpoint}/${fullQueryString}`;

  const query = useQuery<Record<string, any>, Error>({
    queryKey: [ApiCatalog.search.key, queryParams],
    queryFn: async () => {
      const response = await fetch(requestUrl, { credentials: "include" });
      if (!response.ok) {
        logger.error(`Failed to fetch delivery search: ${response.status}`);
      }
      return response.json();
    },
    refetchOnWindowFocus: false,
  });

  return query;
}
